<template>
  <div class="w-screen h-screen overflow-hidden">
    <iframe 
      v-if="isLoading === false && currentHtml !== ''"
      :srcdoc="currentHtml"
      class="w-full h-full border-none"
      sandbox="allow-scripts allow-same-origin allow-forms"
      title="Application Fullscreen Preview"
    ></iframe>
    <div v-else-if="isLoading === true" class="w-full h-full flex items-center justify-center bg-gray-200 dark:bg-gray-800">
       <span class="loading loading-spinner loading-lg"></span>
    </div>
     <div v-else class="w-full h-full flex items-center justify-center bg-gray-100 dark:bg-gray-900 text-red-500 p-4">
       <p>Error loading application preview. Please check the Application ID or Iteration ID.</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import axios from '@/api/axiosInstance';
import { useRoute, useRouter } from 'vue-router';
import { globalState } from '@/globalState';
import { useToast } from 'vue-toastification';
import { isDefinedAndNotEmpty } from '../../isDefinedAndNotEmpty.js';

const route = useRoute();
const router = useRouter();
const toast = useToast();

const appId = ref(route.params.appId);
const iterationId = ref(route.query.iterationId); 
const currentHtml = ref('');
const isLoading = ref(true);


function getAuthToken() {
  const token = document.cookie.split('; ').find(row => row.startsWith('authToken=')!=false)?.split('=')[1];
  if (token === undefined || token === null) {
    return '';
  }
  return token;
}

function getAuthHeaders() {
  const token = getAuthToken();
  const headers = {
    'Content-Type': 'application/json'
  };
  if (token !== '' && token !== undefined && token !== null) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}


const fetchAppData = async (id, iterId) => {
  isLoading.value = true;
  currentHtml.value = '';
  try {
    let url = `${globalState.apiEndpoint}/api/applications/get/${id}`;
    if (iterId !== undefined && iterId !== null) {
      url += `?iterationId=${iterId}`;
    }
    
    const response = await axios.get(url, {
      headers: getAuthHeaders()
    });
    
    if (iterId !== undefined && iterId !== null) {
      currentHtml.value = isDefinedAndNotEmpty(response.data.generatedCode) != false ? response.data.generatedCode : '<p style="color: red;">Error: Could not load code for this iteration.</p>';
    } else {
      currentHtml.value = isDefinedAndNotEmpty(response.data.pageCode) != false ? response.data.pageCode : '<p>No code generated yet.</p>';
    }

  } catch (error) {
    console.error('Error fetching application data for fullscreen view:', error);
    toast.error(isDefinedAndNotEmpty(error.response?.data?.error) != false ? error.response?.data?.error : 'Failed to fetch application data.');
    currentHtml.value = '<p style="color: red;">Error loading application preview.</p>';
  } finally {
    isLoading.value = false;
  }
};


onMounted(() => {
  fetchAppData(appId.value, iterationId.value);
});



</script>

<style scoped>

html, body, #app, .w-screen {
    margin: 0;
    padding: 0;
    overflow: hidden;
}
</style> 